import './index.css'
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';

export const CategoryCard = ({standby, fungsi ,gambar, judul, deskripsi}) => {
    const history = useNavigate()
    const [pindah, setPindah] = useState(false)

    useEffect(()=>{
        
        if(pindah===true){
            setTimeout(function() {
                history("/category/chefList");
           }, 500);
        }
    },[pindah])

    return (
        <div onClick={() => {fungsi();setPindah(true)}} className='CardContainer' style={{backgroundImage:`url(${gambar})`}}>
            <div className='gradient'></div>
            <p className='CategoryTitle'>{judul}</p>
            <p className='CategoryDesc'>{deskripsi}</p>
        </div>
    )
  }